// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "app-" + chunkId + "." + {"679":"928a71723ebaa38fedd7","936":"05531222c1bd47a07a0d"}[chunkId] + ".js";
};